import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';

import { BgImage } from '~/components/atoms/bg-element/BgImage';
import { BlockTitle } from '~/components/atoms/block-title';
import { Icon } from '~/components/ui/icon';
import { Text } from '~/components/ui/text';
import {
  IconWrapper,
  StyledCard,
  StyledCardsWrapper,
  StyledContainer,
  StyledTitle,
} from '~/pages/HomePage/components/benefits/styled';
import { getIsMobile } from '~/store/reducers/app/selectors';
import { COLORS } from '~/styles/colors';

const LIST = [
  {
    id: 1,
    icon: 'Chart2',
    title: 'landing:benefits.rates.title',
    text: 'landing:benefits.rates.description',
    backgroundColor: '#F0FBF3',
  },
  {
    id: 2,
    icon: 'QrCode',
    title: 'landing:benefits.qrs.title',
    text: 'landing:benefits.qrs.description',
    backgroundColor: COLORS.blue50,
  },
  {
    id: 3,
    icon: 'Notes',
    title: 'landing:benefits.notes.title',
    text: 'landing:benefits.notes.description',
    backgroundColor: '#FFEEE3',
  },
  {
    id: 4,
    icon: 'RoundGraph',
    title: 'landing:benefits.statistics.title',
    text: 'landing:benefits.statistics.description',
    backgroundColor: '#FFEEE3',
  },
  {
    id: 5,
    icon: 'Pallete2',
    title: 'landing:benefits.customization.title',
    text: 'landing:benefits.customization.description',
    backgroundColor: COLORS.blue50,
  },
  {
    id: 6,
    icon: 'Download',
    title: 'landing:benefits.download.title',
    text: 'landing:benefits.download.description',
    backgroundColor: '#F0FBF3',
  },
];

export default function Benefits() {
  const { t } = useTranslation();

  const isMobile = useSelector(getIsMobile);

  return (
    <Box sx={{ background: COLORS.white2 }}>
      <StyledContainer className="customContainer" sx={{ position: 'relative' }}>
        <BgImage.circlesFilled $top={152} $left={-98} $zIndex={0} />
        <BgImage.circles $bottom={97} $right={-221} $zIndex={0} />
        <BlockTitle text={t('landing:benefits.headerTitle')} />
        <StyledTitle>
          <Text
            variant={isMobile ? 'h2' : 'h1.5'}
            color={COLORS.textMain}
            sx={{ color: COLORS.textMain, textAlign: 'center' }}
          >
            {t('landing:benefits.title')}
          </Text>
        </StyledTitle>
        <Text
          sx={{ color: COLORS.grey400, maxWidth: '941px', textAlign: 'center', letterSpacing: '0' }}
          variant="buttonSmallRegular"
        >
          {t('landing:benefitSubTitle')}
        </Text>
        <StyledCardsWrapper>
          {LIST.map(({ id, icon, title, text, backgroundColor }) => {
            return (
              <StyledCard key={id}>
                <IconWrapper $backgroundColor={backgroundColor}>
                  <Icon withParentColor={false} size={32} icon={icon} />
                </IconWrapper>
                <Text variant="h3" sx={{ color: COLORS.textMain, letterSpacing: '0' }} component="h3">
                  {t(title)}
                </Text>
                <Text
                  variant="buttonSmallMedium"
                  sx={{ color: COLORS.grey400, letterSpacing: '-0.1px', lineHeight: '20px' }}
                >
                  {t(text)}
                </Text>
              </StyledCard>
            );
          })}
        </StyledCardsWrapper>
      </StyledContainer>
    </Box>
  );
}
